import instance from "@/services/api";

export const foremanAcceptanceAPI = {
  async getList(params) {
    return await instance()
      .get("/project/foreman-acceptance/", { params })
      .then((res) => res?.data);
  },

  async getItems(help_call_id) {
    return await instance()
      .get("/project/foreman-acceptance/items/", { params: { help_call_id } })
      .then((res) => res?.data);
  },

  async accept(help_call_id) {
    return await instance()
      .post(
        "/project/foreman-acceptance/accept/",
        { help_call_id }
      )
      .then((res) => res?.data);
  },
  async getProcessStatus(params = {}) {
    return await instance()
      .get("/project/foreman-acceptance/process_status/read/", { params })
      .then((res) => res?.data);
  },

  async getEntrancesTree(sbs_project_id) {
    return await instance()
      .get("/project/foreman-acceptance/entrances_tree/", {
        params: { sbs_project_id },
      })
      .then((res) => res?.data);
  },

  async getFloors(project_entrance_id) {
    return await instance()
      .get("/project/unsigned/floors/", { params: { project_entrance_id } })
      .then((res) => res?.data);
  },

  async getUspProjects() {
    return await instance()
      .get("/project/project_group/read/")
      .then((res) => res?.data);
  },

  async getProjectTypes() {
    return await instance()
      .get("/project/foreman-acceptance/project_types/")
      .then((res) => res?.data);
  },

  async getContractors() {
    return await instance()
      .get("/project/foreman-acceptance/contractors/")
      .then((res) => res?.data);
  },
};
